import {EdcUiEnvironment} from './edc-ui-environment';

export const environment: EdcUiEnvironment = {
  production: true,
};
